import { useQuery } from '@tanstack/react-query';
import { queryKeyFactory } from 'utils/query-client';
import { loaders } from './admin-benefit-templates.loaders';
import { converters } from './admin-benefit-templates.converters';
import { AdminBenefitTemplatesFilters } from './admin-benefit-templates.types';

export const benefitTemplatesKeys = queryKeyFactory('admin-benefit-templates');

export const useAdminBenefitTemplates = (
  filters: Partial<AdminBenefitTemplatesFilters> = {},
) => {
  return useQuery({
    queryKey: benefitTemplatesKeys.list(filters),
    queryFn: () => loaders.getBenefitTemplates({ filters }),
    select: converters.getBenefitTemplates,
  });
};

export const useAdminBenefitTemplate = (benefitTemplateId: string) => {
  return useQuery({
    queryKey: benefitTemplatesKeys.detail(benefitTemplateId),
    queryFn: () => loaders.getBenefitTemplate({ benefitTemplateId }),
    select: converters.getBenefitTemplate,
    enabled: !!benefitTemplateId,
  });
};
